module.exports = __webpack_public_path__ + "img/order-manage.ebf5b436.svg";